import type { ReactNode } from 'react';

interface CanvasLayoutStateScaffoldProps {
  children?: ReactNode;
  isAnimated?: boolean;
}

export default function CanvasLayoutStateScaffold({
  children,
  isAnimated = false,
}: CanvasLayoutStateScaffoldProps) {
  const animationClassName = isAnimated ? ' animate-pulse' : '';

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="relative min-h-0 flex-1">
        <div className="absolute inset-0 overflow-hidden rounded-3xl lg:flex lg:justify-center">
          <div className="bg-secondary h-full w-full lg:w-[calc(100vw-48px)] lg:shrink-0" />
        </div>

        <div className="pointer-events-none absolute inset-4 z-0">
          <div className="absolute bottom-0 left-0 hidden sm:block">
            <div
              className={`bg-gray-15/40 dark:bg-gray-90/40 h-[52px] w-[52px] rounded-2xl backdrop-blur-md${animationClassName}`}
            />
          </div>

          <div className="absolute bottom-0 right-0">
            <div
              className={`bg-gray-15/40 dark:bg-gray-90/40 h-[52px] w-[52px] rounded-2xl backdrop-blur-md lg:h-[204px] lg:w-[160px]${animationClassName}`}
            />
          </div>

          <div className="absolute inset-x-0 bottom-0 flex justify-center md:bottom-auto md:top-1/2 md:-translate-y-1/2">
            <div
              className={`bg-gray-15/40 dark:bg-gray-90/40 h-12 w-full max-w-[560px] rounded-2xl backdrop-blur-md sm:h-14 md:w-[420px]${animationClassName}`}
            />
          </div>
        </div>

        {children && <div className="absolute inset-0 z-10">{children}</div>}
      </div>

      <div className="pointer-events-none flex flex-col pt-5">
        <div className="flex h-5 flex-col justify-center rounded-lg px-2 sm:px-0">
          <div
            className={`bg-gray-30 dark:bg-gray-70 hidden h-[3px] w-full rounded-full md:block${animationClassName}`}
          />
        </div>

        <div className="flex h-[64px] items-center pr-2 lg:pr-0">
          <div className="flex flex-1 items-center gap-2 pl-2 lg:pl-0">
            <div
              className={`bg-gray-30 dark:bg-gray-70 hidden h-8 w-16 rounded-lg md:block${animationClassName}`}
            />
            <div
              className={`bg-gray-30 dark:bg-gray-70 h-8 w-28 rounded-lg${animationClassName}`}
            />
          </div>

          <div className="flex items-center gap-2">
            <div
              className={`bg-gray-30 dark:bg-gray-70 h-10 w-10 rounded-xl${animationClassName}`}
            />
            <div
              className={`bg-gray-30 dark:bg-gray-70 h-12 w-12 rounded-2xl${animationClassName}`}
            />
            <div
              className={`bg-gray-30 dark:bg-gray-70 h-10 w-10 rounded-xl${animationClassName}`}
            />
          </div>

          <div className="flex flex-1 justify-end gap-2">
            <div
              className={`bg-gray-30 dark:bg-gray-70 hidden h-8 w-24 rounded-lg md:block${animationClassName}`}
            />
            <div
              className={`bg-gray-30 dark:bg-gray-70 h-8 w-10 rounded-lg${animationClassName}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
